import AboutComp from "../components/AboutComp";
import ContactComp from "../components/ContactComp";
import GalleryComp from "../components/GalleryComp";
import ProgramsComp from "../components/ProgramsComp";
import Carousel from "../components/Carousel";
import MissionComp from "../components/MissionComp";
import VisionComp from "../components/VisionComp";

const Home = () => {
  return (
    <>
      <Carousel />
      <VisionComp />
      <MissionComp />
      <AboutComp />
      <ContactComp />
    </>
  );
};

export default Home;
